// Inspired by AI platform component: https://github.com/wix-private/genie/blob/41438345f3a4a9585756fab68b44bcc4a23dd54b/packages/chat-widget-ui-lib/src/ChatWidget/components/ChatMessage/AssistantAvatar/AssistantAvatar.tsx
import { Box } from '@wix/design-system';
import cs from 'classnames';
import React, { FC } from 'react';

import s from './AssistantAvatar.scss';

interface AssistantAvatarProps {
  animated: boolean;
  height?: number;
  width?: number;
}

const enum StarPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export const AssistantAvatar = ({ animated: isLoading, height, width }: AssistantAvatarProps) => (
  <Box position="relative" width={width ? width : '18px'} height={height ? height : '18px'}>
    <Star position={StarPosition.LEFT} className={cs(s.starLeft, { [s.animated]: isLoading })} />
    <Star position={StarPosition.RIGHT} className={cs(s.starRight, { [s.animated]: isLoading })} />
  </Box>
);

const Star: FC<{ className: string; position: StarPosition }> = ({ className, position }) => (
  <svg viewBox="0 0 15 16" fill="none" className={className}>
    <path
      d="M7.32332 0.506935C7.6266 0.506935 7.89098 0.713351 7.96454 1.00758L8.13226 1.67849C8.78348 4.28337 10.8174 6.31729 13.4222 6.96852L14.0932 7.13626C14.3875 7.20983 14.5938 7.47419 14.5938 7.77749C14.5938 8.08078 14.3873 8.34515 14.0932 8.4187L13.4223 8.58643C10.8174 9.23761 8.78347 11.2715 8.13225 13.8764L7.96454 14.5473C7.89098 14.8416 7.6266 15.0479 7.32332 15.0479C7.02003 15.0479 6.75565 14.8416 6.6821 14.5473L6.51439 13.8764C5.86316 11.2715 3.8292 9.23761 1.22426 8.58643L0.553485 8.4187C0.259242 8.34515 0.0528259 8.08078 0.0528259 7.77749C0.0528259 7.47419 0.259229 7.20983 0.553472 7.13626L1.22438 6.96852C3.82926 6.31729 5.86315 4.28337 6.51438 1.67849L6.6821 1.00758C6.75565 0.713351 7.02003 0.506935 7.32332 0.506935Z"
      fill={`url(#paint0_linear_1_${position === StarPosition.LEFT ? '61066' : '61067'})`}
    />
    <defs>
      {position === StarPosition.LEFT ? (
        <linearGradient
          id="paint0_linear_1_61066"
          x1="-1.65058"
          y1="44.422"
          x2="23.9154"
          y2="38.6436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0021FF" />
          <stop offset="0.67" stop-color="#116DFF" />
          <stop offset="1" stop-color="#5FF2AE" />
        </linearGradient>
      ) : (
        <linearGradient
          id="paint0_linear_1_61067"
          x1="-0.770271"
          y1="20.7303"
          x2="11.1605"
          y2="18.0337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0021FF" />
          <stop offset="0.16" stop-color="#116DFF" />
          <stop offset="1" stop-color="#5FF2AE" />
        </linearGradient>
      )}
    </defs>
  </svg>
);
